var Webflow = Webflow || [];
Webflow.push(function () {
  // DOMready has fired
  // May now use jQuery and Webflow api

  gsap.registerPlugin(ScrollTrigger);

  // Load Rive
  const riveInstance = new rive.Rive({
    src: 'https://cdn.prod.website-files.com/6785811e562788f8b3a1b897/67a3f0d1d89e6b73521a38e2_bluesonde_tabs.riv',
    canvas: document.getElementById('riveCanvas'),
    stateMachines: 'State Machine 1',
    autoplay: true,
    onLoad: () => {
      riveInstance.resizeDrawingSurfaceToCanvas();
      updateRiveState(1);
    },
  });

  // Function to update Rive states
  const updateRiveState = (sectionIndex) => {
    let inputs = riveInstance.stateMachineInputs('State Machine 1');
    console.log(inputs);
    let input = inputs.find((i) => i.name === 'Section');
    if (input) input.value = sectionIndex; // Set the value to current section index
  };

  // Create ScrollTrigger for each section
  document.querySelectorAll('.industry-section').forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top center',
      end: 'bottom center',
      onEnter: () => {
        updateRiveState(index + 1);
      },
      onLeaveBack: () => {
        // Reset previous section when scrolling up
        if (index > 0) {
          updateRiveState(index); // Go back to the previous state
        }
      },
    });
  });

  // Sliding lines

  var tl = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.solutions_section_wrapper',
        scrub: true,
        start: 'top top',
      },
    })
    .to(
      '.lines_background-image-1',
      {
        top: '-200%',
      },
      '>'
    )
    .to(
      '.lines_background-image-2',
      {
        top: '-150%',
      },
      '<'
    );

  // Header animations

  var headersTimeline = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.section_header',
        scrub: true,
        start: 'top top',
        end: 'bottom top',
      },
    })
    .to(
      '.w-background-video',
      {
        scale: 1.1,
      },
      '>'
    )
    .to(
      '.header33_content',
      {
        autoAlpha: 0,
      },
      '<'
    );

  // buoy spin
  gsap.set('.buoy-bottom-image', { rotate: 0 });
  gsap.to('.buoy-bottom-image', {
    scrollTrigger: {
      trigger: '.section_construction',
      scrub: true,
      start: 'top bottom',
      end: 'bottom top',
    },
    rotate: 360,
    ease: 'power2.easeInOut',
  });

  let mm = gsap.matchMedia();

  mm.add('(min-width: 991px)', () => {
    const buoyInfoWrappers = document.querySelectorAll('.buoy-info-wrapper');
    const buoyTitles = document.querySelectorAll('.buoy-info-wrapper .buoy-info-title');
    const mainBuoyImage = document.querySelector('#main-buoy-image');

    buoyInfoWrappers.forEach((buoyWrapper) => {
      const buoyDescription = buoyWrapper.querySelector('.buoy-info-description');
      const buoyImage = buoyWrapper.querySelector('.buoy-info-image');
      gsap.set(buoyImage, { opacity: 0 });
      gsap.set(buoyDescription, { opacity: 0 });
    });

    buoyTitles.forEach((buoyTitle) => {
      const parentDiv = buoyTitle.parentElement.parentElement.parentElement;
      const buoyImage = parentDiv.querySelector('.buoy-info-image');
      const buoyDescription = parentDiv.querySelector('.buoy-info-description');
      buoyTitle.addEventListener('mouseenter', () => {
        gsap.to(buoyInfoWrappers, { opacity: 0.4 });
        gsap.to(parentDiv, { opacity: 1 });
        gsap.to(mainBuoyImage, { autoAlpha: 0 });
        gsap.to(buoyDescription, { autoAlpha: 1 });
        gsap.to(buoyImage, { autoAlpha: 1 });
      });
      buoyTitle.addEventListener('mouseleave', () => {
        gsap.to(buoyInfoWrappers, { opacity: 1 });
        gsap.to(parentDiv, { opacity: 1 });
        gsap.to(mainBuoyImage, { autoAlpha: 1 });
        gsap.to(buoyDescription, { autoAlpha: 0 });
        gsap.to(buoyImage, { autoAlpha: 0 });
      });
    });
  });

  mm.add('(max-width: 990px)', () => {
    const monitoringSection = document.querySelector('.monitoring-wrapper');
    const buoyInfoWrappers = document.querySelectorAll('.buoy-info-wrapper');

    buoyInfoWrappers.forEach((buoyWrapper) => {
      buoyWrapper.classList.add('swiper-slide');
    });

    new Swiper(monitoringSection, {
      slidesPerView: 1,
      cssMode: true,
      createElements: true,
      navigation: false,
      pagination: {
        el: monitoringSection.parentElement.querySelector('.custom-pagination'),
        clickable: true,
      },
    });

    const industryGridSection = document.querySelectorAll('.industry-grid');
    const industryTextWrappers = document.querySelectorAll('.industry-text');

    industryTextWrappers.forEach((industryText) => {
      industryText.classList.add('swiper-slide');
    });

    industryGridSection.forEach((industryGrid) => {
      new Swiper(industryGrid, {
        slidesPerView: 1,
        cssMode: true,
        createElements: true,
        navigation: false,
        pagination: {
          el: industryGrid.parentElement.querySelector('.custom-pagination'),
          clickable: true,
        },
      });
    });

    ScrollTrigger.create({
      trigger:'.industry-sections_component',
      start: 'top center',
      onEnter: () => {
        gsap.to('.navbar1_component', {autoAlpha: 0, ease: 'power2.inOut'})
      },
      onEnterBack: () => {
        gsap.to('.navbar1_component', {autoAlpha: 0, ease: 'power2.inOut'})
      },
      onLeave: () => {
        gsap.to('.navbar1_component', {autoAlpha: 1, ease: 'power2.inOut'})
      },
      onLeaveBack: () => {
        gsap.to('.navbar1_component', {autoAlpha: 1, ease: 'power2.inOut'})
      }
    });
  });

  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis();

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
});
